import { ROLES } from "../role.constants";

export const mentorRoutes = [
  {
    path: "/mentor",
    element: <div>Mentor</div>,
    roles: [ROLES.MENTOR],
  },
];
